module.exports = __webpack_public_path__ + "static/media/ai.377c542a.svg";